import React, { useState } from "react";
import { useConsent } from "../context/ConsentContext";
import { useI18n } from "../i18n/I18nContext";
import { MapPin, Play } from "lucide-react";
import { Button } from "./ui/button";

// Static map (no third-party request) until user consents/acts. Loi 25 compliant.
export default function StaticMap() {
  const { functionalAllowed } = useConsent();
  const { t } = useI18n();
  const [loaded, setLoaded] = useState(false);

  const embedSrc =
    "https://www.openstreetmap.org/export/embed.html?bbox=-73.72%2C45.63%2C-73.68%2C45.66&layer=mapnik&marker=45.645%2C-73.70";

  if (functionalAllowed || loaded) {
    return (
      <iframe title={t("map.title")} src={embedSrc} data-testid="interactive-map"
        className="h-80 w-full rounded-2xl border border-black/10" loading="lazy" />
    );
  }

  return (
    <div className="relative flex h-80 w-full flex-col items-center justify-center gap-4 rounded-2xl border border-black/10 bg-[#EEF1E9] p-6 text-center"
      data-testid="static-map">
      <MapPin className="h-10 w-10 text-[#2A9D8F]" />
      <div>
        <p className="font-semibold text-[#2D3142]">4825, rue Cyrille Delage, Laval (Auteuil)</p>
        <p className="mt-1 text-sm text-[#5C6370]">{t("map.notice")}</p>
      </div>
      <Button onClick={() => setLoaded(true)} data-testid="load-map-button"
        className="rounded-full min-h-[44px] bg-[#2A9D8F] hover:bg-[#21867A]">
        <Play className="mr-2 h-4 w-4" /> {t("map.loadInteractive")}
      </Button>
    </div>
  );
}
